import { useHistory, useLocation } from 'react-router'
import { useCallback, useEffect, useMemo, useState } from 'react'
import queryString from 'query-string'

export const useOrderListFilterByExpertLocation = () => {
  const location = useLocation()
  const history = useHistory()
  const queryObject = useMemo(() => queryString.parse(location.search), [location])
  const filterValue = useMemo(() => (Array.isArray(queryObject.expert) ? queryObject.expert[0] : queryObject.expert), [queryObject.expert])

  const [expert, setExpert] = useState<string>(filterValue || '')

  useEffect(() => {
    setExpert(filterValue || '')
  }, [filterValue])

  const get = useCallback(() => expert, [expert])

  const set = useCallback(
    (value: string) => {
      setExpert(value)
      const searchParams = new URLSearchParams(history.location.search)
      if (value) {
        searchParams.set('expert', value)
      } else {
        searchParams.delete('expert')
      }
      history.push({ search: searchParams.toString() })
    },
    [history],
  )

  return useMemo(() => ({ get, set }), [get, set])
}
